import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TableCell, Typography } from '@material-ui/core';
import { styled, makeStyles } from '@material-ui/styles';

const NoPaddingTableCell = styled(TableCell)({
  padding: 0,
  border: 'none',
  textAlign: 'center',
});

const useStyles = makeStyles(() => ({
  healthyBottom: {
    paddingBottom: 5,
  },
  topBottomMargins: {
    marginTop: 20,
    marginBottom: 10,
  },
}));

const DepthCell = ({ value }) => {
  const classes = useStyles();

  return (
    <NoPaddingTableCell key={Math.random() * 10000}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        key={Math.random() * 10000}
        className={classes.topBottomMargins}
      >
        <Grid item key={Math.random() * 10000}>
          <Typography variant="h3" key={Math.random() * 10000} className={classes.healthyBottom}>
            {`${value * 6}"`}
          </Typography>
        </Grid>
      </Grid>
    </NoPaddingTableCell>
  );
};

DepthCell.propTypes = {
  value: PropTypes.number,
};

DepthCell.defaultProps = {
  value: 0,
};

export default DepthCell;
